// extracted by mini-css-extract-plugin
var _1 = "poiuh";
var _2 = "S50_1";
export { _1 as "base", _2 as "chart" }
